import React from "react";
import styles from "./styles.module.scss";
import { UIText } from "src/components/uIKit";
import { CHECKBOX_TYPE } from "src/utils/enums";
import classNames from "classnames";
interface UICheckBoxProps {
  onChange: any;
  checked: boolean;
  text?: string;
  type?: CHECKBOX_TYPE;
  className?: string;
  ariaLabel?: string;
}

const UICheckBox: React.FC<UICheckBoxProps> = ({
  onChange,
  checked,
  text,
  type = CHECKBOX_TYPE.ROUNDED,
  className,
  ariaLabel
}) => {
  return (
    <div aria-description={text} aria-label={ariaLabel}>
      {text ? (
        <div className={styles.checkboxSquireWrapper}>
          <UIText text={text} size={16} weight={400} style={styles.mRight} />
          <input
            aria-label={ariaLabel}
            aria-checked={checked}
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className={classNames(styles.checkboxSquire, className)}
          />
        </div>
      ) : type === CHECKBOX_TYPE.ROUNDED ? (
        <input
          aria-label={ariaLabel}
          aria-checked={checked}
          type="checkbox"
          className={classNames(styles.checkbox, className)}
          checked={checked}
          onChange={onChange}
        />
      ) : (
        <input
          aria-label={ariaLabel}
          aria-checked={checked}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={classNames(styles.checkboxSquire, className)}
        />
      )}
    </div>
  );
};

export default UICheckBox;
